import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Button } from '@/components/ui/button';
import { DeliveryInfo, Product } from '../types/order';
import DeliveryStatus from './DeliveryStatusForm';
import { getProductQuantity } from '../utils';

interface DeliveryTableProps {
    deliveries: DeliveryInfo[];
    onEdit: (id: string | number) => void;
    products: Product[];
    deliveryButtonState: boolean;
    finalStatus:any;
}

export const DeliveryTable = ({ deliveries, products, deliveryButtonState , finalStatus, onEdit}: DeliveryTableProps) => {
    return (
        <div className="">
            <Table className='rounded-t-lg'>
                <TableHeader className='bg-[#EEEEEE] rounded-t-lg'>
                    <TableRow className='whitespace-nowrap rounded-t-lg text-[#666666] font-medium text-sm leading-4 tracking-[2%]'>
                        <TableHead>Delivery ID</TableHead>
                        <TableHead>Customers</TableHead>
                        <TableHead>Products</TableHead>
                        <TableHead>Delivery Mode</TableHead>
                        <TableHead>Delivery Address</TableHead>
                        <TableHead>Status</TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {deliveries.map((delivery) => {
                        const address = Object.entries(delivery.address_detail).filter(([key]) => (key !== 'id' && key !== 'created_at')).map(([, value]) => value).filter((value) => value).join(', ');                                                   
                        const defaultData = {
                            status: delivery.Status,
                            date: new Date().toISOString(),
                            quantity: getProductQuantity(delivery.generic_order_product_id, products)
                        }
                        return (
                            <TableRow className='py-2 px-4' key={Math.random().toString()}>
                                <TableCell>{delivery.delivery_id || '-'}</TableCell>
                                <TableCell>{delivery.full_name}</TableCell>
                                <TableCell>
                                    {delivery?.product_name}
                                </TableCell>
                                <TableCell>{delivery.delivery_mode || '-'}</TableCell>
                                <TableCell className=' max-w-[200px]'>{address}</TableCell>
                                <TableCell className='flex items-center flex-col gap-2'>
                                    {delivery.Status}
                                    <div className="flex items-center gap-2">
                                        <DeliveryStatus disabled={deliveryButtonState || defaultData.status === 'Delivered' || defaultData?.status === "Cancelled" || finalStatus?.length > 0} id={delivery.uuid} defaultValues={defaultData}>
                                            <Button
                                                variant="ghost"
                                                size="icon"
                                            >
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M3.34375 4.375H2.51042C2.06839 4.375 1.64447 4.55059 1.33191 4.86316C1.01934 5.17572 0.84375 5.59964 0.84375 6.04167V13.5417C0.84375 13.9837 1.01934 14.4076 1.33191 14.7202C1.64447 15.0327 2.06839 15.2083 2.51042 15.2083H10.0104C10.4524 15.2083 10.8764 15.0327 11.1889 14.7202C11.5015 14.4076 11.6771 13.9837 11.6771 13.5417V12.7083" stroke="#165FE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M10.8411 2.71363L13.3411 5.21363M14.4953 4.03446C14.8235 3.70626 15.0079 3.26112 15.0079 2.79696C15.0079 2.33281 14.8235 1.88767 14.4953 1.55946C14.1671 1.23126 13.722 1.04688 13.2578 1.04688C12.7937 1.04687 12.3485 1.23126 12.0203 1.55946L5.00781 8.54696V11.047H7.50781L14.4953 4.03446Z" stroke="#165FE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            </Button>
                                        </DeliveryStatus>
                                        <Button
                                            variant="ghost"
                                            size="icon"
                                            onClick={() => {
                                                onEdit(delivery.uuid);
                                            }}
                                            className='text-blue-700 hover:bg-blue-100'
                                        >
                                            Edit
                                        </Button>
                                    </div>
                                </TableCell>
                            </TableRow>
                        )
                    })}
                </TableBody>
            </Table>
        </div>
    );
};